import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "m13.231 7.104-6.914 8.375a.833.833 0 0 0 .112 1.173l.879.726-2.529 3.062a.683.683 0 0 0 1.054.87l2.528-3.063.882.729a.833.833 0 0 0 1.173-.112L21.88 4.98a.833.833 0 0 0-.113-1.173l-2.814-2.324a.833.833 0 0 0-1.173.112l-3.69 4.467-.004-.003-.86 1.041.004.004Zm5.28-4.04-3.263 3.953 1.786 1.475 3.263-3.953-1.786-1.475Zm-2.337 6.47-1.786-1.475-6.49 7.86 1.786 1.476 6.49-7.862Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function c(d, a) {
  return e(), t("svg", l, [...r]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
